import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import css from "./progress_bar.less";

const Dot = ({ dotLevel, currentLevel, isOverdue }) => {
  const style = { left: `${dotLevel * 25}%` };
  const isFirstDot = dotLevel === 0;
  const isDotReached = currentLevel >= dotLevel;

  const dotClass = classNames(css.dot, {
    [css.dotZero]: isFirstDot,
    [css.dotEmpty]: isDotReached,
    [css.dotOverdue]: !isFirstDot && !isDotReached && isOverdue
  });

  return (
    <div className={css.dotWrap}>
      <div className={dotClass} style={style} />
    </div>
  );
};

Dot.propTypes = {
  dotLevel: PropTypes.number.isRequired,
  currentLevel: PropTypes.number.isRequired,
  isOverdue: PropTypes.bool.isRequired
};

export default Dot;
